export enum BurnoutStatus {
  Unknown = 0,
  Before = 1,
  After = 2
}

var BurnoutStatusTitles =
  [
    "Unknown",
    "Before",
    "After"
  ];

var BurnoutStatusKeys = Object.values(BurnoutStatus).filter(p => typeof BurnoutStatus[p] === "string");

export function burnoutStatusTitle(burnoutStatus: BurnoutStatus): string {
  let index = BurnoutStatusKeys.indexOf(burnoutStatus);
  return BurnoutStatusTitles[index];
}

export enum TargetFamily {
  Unknown = 0,
  Abt = 1,
  Ballistic = 2,
  Rbm = 3,
  Tbm = 4,
  Interceptor = 5,
  Artillery = 6,
  Birds = 7,
  Clouds = 8,
  Cars = 9,
  Boats = 10,
  Other = 11,
  SurfaceAirMissile = 12,
  Explosion = 13,
  ShoreSeaMissile = 14
}

var TargetFamilyTitles =
  [
    "Unknown",
    "ABT",
    "Ballistic",
    "RBM",
    "TBM",
    "Interceptor",
    "Artillery",
    "Birds",
    "Clouds",
    "Cars",
    "Boats",
    "Other",
    "SAM",
    "Explosion",
    "SSM"
  ];
  
var TargetFamilyKeys = Object.values(TargetFamily).filter(p => typeof TargetFamily[p] === "string");

export function targetFamilyTitle(targetFamily: TargetFamily): string {
  let index = TargetFamilyKeys.indexOf(targetFamily);
  return TargetFamilyTitles[index];
}

export enum BallisticManeuver {
  Unknown = 0,
  NotValid = 1,
  Yes = 2,
  No = 3
}

var BallisticManeuverTitles =
  [
    "Unknown",
    "Not Valid",
    "Yes",
    "No"
  ];

var BallisticManeuverKeys = Object.values(BallisticManeuver).filter(p => typeof BallisticManeuver[p] === "string");

export function ballisticManeuverTitle(ballisticManeuver: BallisticManeuver): string {
  let index = BallisticManeuverKeys.indexOf(ballisticManeuver);
  return BallisticManeuverTitles[index];
}

export enum FieldSource {
  Unknown = -1,
  System = 0,
  Lamdan = 1,
  Menatev = 2
}

var FieldSourceTitles =
  [
    "Unknown",
    "System",
    "Lamdan",
    "Menatev"
  ];

export var FieldSourceKeys = Object.values(FieldSource).filter(p => typeof FieldSource[p] === "string");

export function fieldSourceTitle(fieldSource: FieldSource): string {
  let index = FieldSourceKeys.indexOf(fieldSource);
  return FieldSourceTitles[index];
}

export enum NatNaiOperationAction {
  Create = 0,
  Update = 1,
  Delete = 2
}

export enum GeometricShape {
  Polygon = 0,
  Circle = 1
}

export enum NaiOrNat {
  Nai = 1,
  Nat = 2
}
